import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ProfilePageModule } from '@hiptraveler/features/leaflet-map';

import { MapContentComponent } from './map-content.component';

const MODULES = [
  CommonModule,
  TranslateModule
];

const LIBRARIES = [
  ProfilePageModule
];

const COMPONENTS = [
  MapContentComponent
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    MapContentComponent
  ]
})
export class MapContentModule { }
